<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="3" offset="9">
        <ActionButton type="link" icon="mdi-square-edit-outline" @click="openProfileDialog()">
          {{label("edit")}}
        </ActionButton>
      </v-col>
      <v-dialog v-model="dialogs.profile" max-width="50%" content-class="profileEditDialog" @click:outside="closeProfileDialog">
        <PersonProfileEditPage :close="closeProfileDialog" :open="dialogs.profile" @error="onError" />
      </v-dialog>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-col cols="10" offset="1" class="mt-6">
          <MessageBox type="primary" :message="label('attention')"/>
        </v-col>
        <PersonProfileDetails :person="person" :user="user" :consts="consts" owner/>
      </v-col>
    </v-row>
    <v-row justify="end" v-if="false">
      <v-col cols="3" offset="9">
        {{label("unsubscribe1")}}
        <TextLink to="/clients/unsubscribe" color="#1976d2">{{label("here")}}</TextLink>
        {{label("unsubscribe2")}}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import PersonProfileDetails from "./PersonProfileDetails";
  import PersonProfileEditPage from "../pages/clients/PersonProfileEditPage";
  import TextLink from "../atoms/TextLink";
  import ActionButton from "../molecules/ActionButton";
  import MessageBox from "../atoms/MessageBox";
  import {mapGetters} from "vuex";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "PersonProfile",
    computed: {
      ...mapGetters("user", ["user"]),
      ...mapGetters("client", ["person"]),
      ...mapGetters("system", ["consts"])
    },
    methods: {
      openProfileDialog () {
        this.dialogs.profile = true;
      },
      closeProfileDialog () {
        this.dialogs.profile = false;
        const dialog = document.getElementsByClassName('profileEditDialog')[0];
        dialog.scrollTop = 0;
      },
      onError (el) {
        const dialog = document.getElementsByClassName('profileEditDialog')[0];
        dialog.scrollTop = el.offsetTop;
      }
    },
    components: {
      ActionButton,
      PersonProfileDetails,
      PersonProfileEditPage,
      TextLink,
      MessageBox,
    },
    data () {
      return {
        dialogs: {
          profile: false,
        }
      }
    },
  }
</script>

<style scoped>

</style>
